import axiosCall from "./axiosCall";
import { BASE_URL, CLIENT_ID_PPP, FAF_AUTH, PARTNER_AUTH, PARTNER_BROWSER_ID, REGISTRATION_CLIENT_SECRET_FAF, REGISTRATION_CLIENT_SECRET_PPP, SALESFORCE_BASE_URL } from "../constant/Constants";
import { toast } from "react-toastify";
import axios from "axios";

const browserID = '67656787tjhe3322205173san16'

//BrowserID Verification Service
export const partnerBrowserIDVerify = async (callback = () => { }) => {
    const response = await axiosCall('post', `/Partner/v1/ValidateSession/3?`, PARTNER_AUTH, `BrowserID=${PARTNER_BROWSER_ID.ID}`, null, 'PARTNER');
    if (response?.data?.ResponseDetails?.Available == 'true') {
        callback();
    } else {
        toast.error('Session Expired');
        // setTimeout(() => {
        //     window.location.assign(window.location.origin);
        // }, 2000);
    }
    return { res: response.data, apiCall: '' }
}


// Update portal user
export const userEmailUpdate = async ({ email, portalID }) => {
    let browserID=PARTNER_BROWSER_ID.ID
    let reqbody = {

        "RequestDetails": {

            "PortalID": portalID

        },

        "PartnerPortalUser": {

            // "FirstName":"Test",

            // "LastName":"Dave",

            "EmailAddress": email.existingEmail,

            "NewEmailAddress": email.newEmail,

            "PortalType": "Partner"

        }

    }
    const response = await axiosCall('post', `/Partner/v1/UpdateEmail/FAF?`, PARTNER_AUTH, `BrowserID=${browserID}`, reqbody, 'PARTNER');
    return response.data
}

// Oauth Service in Partner portal
export const outhService = async () => {

    const data = {
        "grant_type": "password",
        "username": "PPPAPI",
        "password": "rules@12",
        "client_id": CLIENT_ID_PPP,
        "client_secret": REGISTRATION_CLIENT_SECRET_PPP
    }
    const headers = {
        'Content-type': 'application/x-www-form-urlencoded'
    }
    try{
        const response = await axiosCall('post', `/PRRestService/oauth2/v1/token`, headers, null, data, "PARTNER");
        return response.data
    }catch{
      return false
    }
}

// Oauth Service on salesforce service
export const oauthServiceSalesforce = async (callback = () => { }) => {

    const headers = {
        'Content-type': 'application/x-www-form-urlencoded'
    }
    // const response = await axiosCall('post', `rd-oauth/oauth2/token?`, headers, '', null, "salesforceParam");
    const response = await axios({
        method: "post",
        url: `${SALESFORCE_BASE_URL}rd-oauth/oauth2/token?`,
        headers: headers,
        params: null,
        data: null
    });

    callback(response.data.access_token)
    return response.data
}


export const sessionExtend = async ({ BrowserId, portalUserID }) => {
    let data = {
        "RequestDetails": {
            "ServiceName": "Logout Service",
            "RequestID": "<14-digit-GUID>",
            "Application": "CPR",
            "RequestTime": "<Timestamp of the Request>",
            "BrowserToken": "<Unique MD5>",
            "PortalID": portalUserID
        }
    }


    const response = await axiosCall('post', `/Users/v1/ExtendSession/FAF?`, PARTNER_AUTH, `BrowserID=${BrowserId}`, data, "FAF");
    return response.data
}

//Logout API
export const logOutService = async ({ BrowserId, portalUserID },callBack=()=>{}) => {
    const response = await axiosCall('post', `/Users/v1/Logout/Patient/FAF?`, PARTNER_AUTH, `BrowserID=${BrowserId}`, { "PortalID": portalUserID }, "FAF");
    callBack(response.data)
    return response.data
}

//Partner Details Service
export const partnerDetails = async ({ BrowserId, EIN, authorization }) => {
    const response = await axiosCall('get', `/v1/data/D_GetEINDetailsFromKylo?`, { 'Authorization': authorization }, `EIN=${EIN}`, null, "PARTNER");
    return response.data
}
//EINs Service
export const EinService = async ({ BrowserId, EIN, authorization, faildCallback, successCallback }) => {
    const response = await axiosCall('get', `/v1/data/D_AdditionalProviders?`, { 'Authorization': authorization }, `ProviderID=E-${EIN}&ProviderType=Partner`, null, 'PARTNER');
    let data = response.data
    if (data.AdditionalProviderAddress != undefined && data.AdditionalProviderAddress.length != 0) {
        successCallback(data)
    } else {
        faildCallback(EIN)
    }
    return response.data
}

//Partner Login Service
export const fetchLogin = async ({ BrowserId, email, password, prevSession, access_token, authorization }) => {
    const data = {

        "PartnerPortalUser": {
            "EmailAddress": email,
            "Password": password,
            "EndSession": prevSession
        }
    }
    const response = await axiosCall('post', `/Partner/v1/Login/Partner?`, { 'Authorization': `${authorization}` }, `BrowserID=${BrowserId}`, data, 'PARTNER');
    return response.data
}

// hash value validate URL
export const ValidateURL = async ({ BrowserId, getHashValue, authorization }) => {
    const data = {
        "PartnerPortalUser": {
            "Hash": getHashValue,
        }
    }
    const response = await axiosCall('post', `/Users/v1/ValidateURL/3/Partner?`, { 'Authorization': authorization }, `BrowserID=${BrowserId}`, data, 'PARTNER');
    return response.data
}

// update Password service 
export const updatePasswordService = async ({ BrowserId, password, getHashValue, authorization }) => {
    const data = {
        "RequestDetails": {
            "Application": "FAF"
        },

        "PartnerPortalUser": {
            "Hash": getHashValue,
            "Password": password
        }

    }
    const response = await axiosCall('post', `/Users/v1/UpdatePassword/Partner/3?`, { 'Authorization': authorization }, `BrowserID=${BrowserId}`, data, 'PARTNER');
    return response.data
}

//forget password service
export const forgetPasswordService = async ({ BrowserId, Email, authorization }) => {
    const data = {
        "RequestDetails": {
            "Application": "FAF"
        },

        "PartnerPortalUser": {
            "EmailAddress": Email
        }

    }
    const response = await axiosCall('post', `/Users/v1/ResetPassword/Partner/3?`, { 'Authorization': authorization }, `BrowserID=${BrowserId}`, data, 'PARTNER');
    return response.data
}

//Partner Registration Service
export const partnerRegister = async ({ BrowserId, regDetails, access_token, authorization }) => {
    const data = {
        "RequestDetails":
        {
            "Application": "FAF"
        },
        "PartnerPortalUser":
        {
            "Policy_Agree": true,
            "UserType": regDetails.UserType,
            "EINNumber": regDetails.EINNumber,
            "FacilityPracticeName": regDetails.FacilityPracticeName,
            "OrganizationName": regDetails.OrganizationName,
            "FirstName": regDetails.firstName,
            "LastName": regDetails.lastName,
            "FullName": regDetails.firstName + " " + regDetails.lastName,
            "EmailAddress": regDetails.EmailAddress,
            "AddressLine1": regDetails.AddressLine1,
            "AddressLine2": "",
            "City": regDetails.City,
            "State": regDetails.State,
            "ZipCode": regDetails.ZipCode,
            "PhoneNumber": regDetails.PhoneNumber,
            "FaxNumber": regDetails.FaxNumber,
            "OptInMailSelected": regDetails.OptInMailSelected,
            "IsProviderUpdated": regDetails.IsProviderUpdated,
            "AddressVerified": regDetails.AddressVerified,
            "SSVerifiedAddress": regDetails.SSVerifiedAddress,
            "IsValid": regDetails.IsValid,
            "NoMatch": regDetails.NoMatch,
            "PartialMatch": regDetails.PartialMatch,
            "ExactMatch": regDetails.ExactMatch,
            "SecInfoNotMatch": regDetails.SecInfoNotMatch,
            "Password":regDetails.Password,
            "IsAgreedtoTerms" :true,
        }
    }
    const response = await axiosCall('post', `/Partner/v1/Registration/Partner/3?`, { 'Authorization': authorization }, `BrowserID=${BrowserId}`, data, 'PARTNER');
    // const response = await axiosCall('post', `${BASE_URL}/api/Partner/v1/Registration/Partner/3?BrowserID=${preAuth}`,{ 'Authorization': `Bearer ${access_token}` }, null, data);
    return response.data
}